'use client';

import { useEffect, useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { MinSchedulesRequiredField } from '@/features/tournament-wizard/blocks';

interface EditMinSchedulesRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentValue: number;
  onSave: (value: number) => Promise<boolean>;
  isLoading: boolean;
}

const MIN = 1;
const MAX = 50;

export function EditMinSchedulesRequiredModal({
  isOpen,
  onClose,
  currentValue,
  onSave,
  isLoading,
}: EditMinSchedulesRequiredModalProps) {
  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    if (!isOpen) return;
    const clamped = Math.max(MIN, Math.min(Math.floor(currentValue), MAX));
    setValue(Number.isNaN(clamped) ? MIN : clamped);
  }, [isOpen, currentValue]);

  const handleSave = async () => {
    const clamped = Math.max(MIN, Math.min(Math.floor(value), MAX));
    await onSave(clamped);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Disponibilidad Mínima"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <MinSchedulesRequiredField
          value={value}
          onChange={setValue}
          wrapInCard={false}
          inputId="edit-min-schedules-required"
        />
      </div>
    </EditModal>
  );
}
